import { Attr, BelongsTo, HasMany, Model } from "spraypaint";

import { ApplicationRecord } from "shared/services/spraypaint";

import type ActiveStorageAttachment from "./ActiveStorageAttachment";
import type RadioStation from "./RadioStation";
import type TvChannel from "./TvChannel";
import type User from "./User";

@Model()
class ManualBroadcastUpload extends ApplicationRecord {
  static jsonapiType = "manual_broadcast_uploads";

  @Attr({ persist: false }) archivedAt: string;

  @Attr({ persist: false }) createdAt: string;

  @HasMany() mediaFiles: ActiveStorageAttachment[];

  @BelongsTo() source: TvChannel | RadioStation;

  @Attr() sourceId: number;

  @Attr() sourceName: string;

  @Attr() sourceType: string;

  @Attr() startTime: string;

  @Attr() timeZone: string;

  @Attr({ persist: false }) updatedAt: string;

  @BelongsTo() user: User;

  @Attr() userId: number;

  @Attr() userName: string;
}

export default ManualBroadcastUpload;
